/** @jsxImportSource @emotion/react */

import { FC } from "react";
import { css, Global, ThemeProvider as EmThemeProvider } from "@emotion/react";
import { RMWCProvider } from "@rmwc/provider";
import { ThemeProvider as MdThemeProvider } from "@rmwc/theme";
import Direction from "../../../commons/Direction";
import defaultConfigs from "../../../commons/configs";
import ConfigContext from "../../ConfigContext";
import { ContextProvider } from "../../../store";
import Notification from "../../Misc/Notification";
import useThemeType from "../../../commons/hooks/use-them-type";
import { ThemeType } from "../../../commons/theme";
import { UiModuleProviderPropType } from "./commons/UiModuleProviderPropType";

require("../../../assets/fonts/fonts.css");

const UiModuleProvider: FC<UiModuleProviderPropType> = ({
  children,
  direction = Direction.RTL,
  themeType = ThemeType.DARK,
}) => {
  const { setThemeType, theme } = useThemeType(themeType);
  const configs = { ...defaultConfigs, setThemeType, direction };

  const styles = css`
    * {
      font-family: IRANSans;
      box-sizing: inherit;
    }

    body,
    html {
      font-family: IRANSans;
      margin: 0;
      height: 100%;
      box-sizing: border-box;
      background-color: ${theme.bodyBackground};
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    a {
      text-decoration: none;
    }
  `;

  return (
    <RMWCProvider>
      <MdThemeProvider options={theme.material}>
        <Global styles={styles} />
        <EmThemeProvider theme={theme}>
          <ConfigContext.Provider value={configs}>
            <ContextProvider>
              <Notification>{children}</Notification>
            </ContextProvider>
          </ConfigContext.Provider>
        </EmThemeProvider>
      </MdThemeProvider>
    </RMWCProvider>
  );
};

export default UiModuleProvider;
